import $ from 'jquery';
import Swiper from 'swiper';

import { $Elements, Breakpoints, Classes, Durations, Events } from './constants';
import { disableBodyScroll, enableBodyScroll, smoothScrollTo, wait } from './helpers';
import {Mousewheel, Navigation } from 'swiper/modules';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Menu ----------

	$Elements.PageWrapper.on('click', '.menu-toggle, a[href="#menu-wrapper"], .menu-overlay', async function(e) {
		e.preventDefault();

		if($Elements.body.hasClass(Classes.menuOpen)) {
			$Elements.window.trigger('menu-close')
			$Elements.body.removeClass(Classes.menuOpen);
			enableBodyScroll();
			await wait(Durations.menu.ms);
			$Elements.window.trigger('menu-closed')
		}
		else {
			$Elements.window.trigger('menu-open')
			$Elements.body.addClass(Classes.menuOpen);
			disableBodyScroll();
			await wait(Durations.menu.ms);
			$Elements.window.trigger('menu-opened')
		}
	});

	$Elements.PageWrapper.on('click', '.navbar-menu a, .menu-wrapper a', function(e) {

		const linkTarget = this.getAttribute('href');
		const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

		if(sectionTarget.substring(0, 1) === '#') {

			e.preventDefault();

			const section = $(sectionTarget);

			if(section.length) {

				window.history.replaceState(null, null, sectionTarget);

				$Elements.body.removeClass(Classes.menuOpen);
				enableBodyScroll()
				smoothScrollTo(section);
			}
			else if(sectionTarget !== '#') {
				window.location = linkTarget;
			}
		}
	});

	// ---------- Carousel ----------

	$('.menu-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: false,
				observer: true,
				createElements: true,
				centeredSlides: true,
				slideToClickedSlide: true,
				mousewheel: true,
				allowTouchMove: true,
				modules: [ Navigation,Mousewheel],
				breakpoints: {
					1024: {
						navigation: {
							nextEl: this.querySelector('.swiper-button-next'),
							prevEl: this.querySelector('.swiper-button-prev'),
						},
					}
				},
			});

			swiper.on('slideChange', () => {
				$('.menu-links .btn').removeClass(Classes.active);
				$('.menu-links .btn[data-slide=' + swiper.realIndex + ']').addClass(Classes.active);
			});

			$Elements.window.on('menu-open', () => {
				const current = swiper.slides.findIndex(slide => slide.classList.contains(Classes.active));
				if(current > -1) {
					swiper.slideTo(current, 0);
				}
			});
		}
	});

});

$Elements.document.on(Events.page.loaded, () => {

	const linkTarget = window.location.href;
	const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

	if(sectionTarget.substring(0, 1) === '#') {

		const section = $(sectionTarget);

		if(section.length) {
			smoothScrollTo(section, 0);
		}
	}
});
